export default __webpack_public_path__ + "static/media/136.5996aff0.gif";